import styled from 'styled-components';
import {
  Table as SemanticTable,
  Dropdown as SemanticDropdown,
} from 'semantic-ui-react';

const Table = styled(SemanticTable)``;

const Column = styled(Table.Cell)`
  &&& { 
    ${({ noborder }) => (noborder ? 'border-top: none;' : '')}
  }

  &&&&& {
    padding: 7px 11px;
  }
`;

const Row = styled(Table.Row)`
  cursor: pointer;
  :hover { 
    background: ${({ theme }) => theme.color.rowHover};
  }
`;

const Dropdown = styled(SemanticDropdown)``;

const DeleteItem = styled.div`
  color: ${({ theme }) => theme.color.textError};
`;

const Text = styled.span`
  ${({ marginleft }) => (marginleft ? 'margin-left: 20px;' : '')}
`;

export {
  Column,
  Row,
  Dropdown,
  DeleteItem,
  Text,
};
